<template>
  <div class="personal-detail">
    <v-row>
      <v-col sm="4">
        <label class="label-input">{{ $t("_REGISTER.FULLNAME") }}*</label>
        <input-text
          :placeholder="$t('_REGISTER.YOUR_FULLNAME')"
          maxlength="50"
          :model.sync="data.fullName"
          :error.sync="errors.fullName.error"
        />
      </v-col>
      <v-col sm="4">
        <v-radio-group class="sex" row v-model="data.gender">
          <v-radio color="indigo darken-3" :label="$t('_REGISTER.MALE')" :value="1"></v-radio>
          <v-radio color="indigo darken-3" :label="$t('_REGISTER.FEMALE')" :value="0"></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="4">
        <label class="label-input">{{ $t("_REGISTER.PERSONAL_PHONE") }}*</label>
        <input-text
          placeholder="(+84)"
          :regex="REGEX_PHONE"
          :model.sync="data.phone"
          :error.sync="errors.phone.error"
          :errorMessage="errors.phone.message"
        />
      </v-col>
      <v-col sm="4">
        <label class="label-input">{{ $t("_REGISTER.EMAIL") }}*</label>
        <input-text
          :placeholder="$t('_REGISTER.YOUR_EMAIL')"
          :model.sync="data.email"
          :error.sync="errors.email.error"
        />
      </v-col>
      <v-col sm="4">
        <label class="label-input">{{ $t("_REGISTER.POSITION") }}*</label>
        <input-text
          maxlength="50"
          :placeholder="$t('_REGISTER.YOUR_POSITION')"
          :model.sync="data.position"
          :error.sync="errors.position.error"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Input from "@/components/Utils/Input.vue";
import {
  REGEX_PHONE,
  REGEX_EMAIL_SYMBOL,
  REGEX_UNICODE
} from "@/_helpers/constant.js";
import { _validateFormI18n, _alert } from "@/_helpers/function.js";
import { getPD_ERROR } from "@/_helpers/config.js";
export default {
  name: "PersonalDetail",
  components: {
    "input-text": Input
  },
  props: {
    msg: String
  },
  data() {
    return {
      data: {
        fullName: null,
        gender: 1,
        phone: null,
        email: null,
        position: null
      },
      source: null,
			medium: null,
			campaign: null,
			content: null,
			term: null,
      errors: getPD_ERROR(),
      isNotFillFull: null
    };
  },
  created() {
    	const params = new URL(location.href).searchParams;
    if ( params.get('utm_source')) {
			this.source =  params.get('utm_source');
			this.$cookies.set('utm_source', this.source, 60 * 60 * 24);
		}
		if (params.get('utm_medium')) {
			this.medium = params.get('utm_medium');
			this.$cookies.set('utm_medium', this.medium, 60 * 60 * 24);
		}
		if (params.get('utm_campaign')) {
			this.campaign = params.get('utm_campaign');
			this.$cookies.set('utm_campaign', this.campaign, 60 * 60 * 24);
		}
		if (params.get('utm_content')) {
			this.content = params.get('utm_content');
			this.$cookies.set('utm_content', this.content, 60 * 60 * 24);
		}
		if (params.get('utm_term')) {
			this.term = params.get('utm_term');
			this.$cookies.set('utm_term', this.term, 60 * 60 * 24);
		}
    if (this.$store.state.modulesRegister.personDetail.length <= 0)
      return false;
    this.data = this.$store.state.modulesRegister.personDetail;
  },
  mounted() {
    document.querySelector(".btn-next").disabled = true;
    document.querySelector(".btn-next").classList.remove("btn-indigo");
  },
  watch: {
    data: {
      handler(value) {
        this.isNotFillFull =
          Object.keys(value).filter(x => !value[x] && value[x] !== 0).length >
          0;
      },
      deep: true
    },
    errors: {
      handler(value) {
        if (this.isNotFillFull) {
          document.querySelector(".btn-next").disabled = true;
          document.querySelector(".btn-next").classList.remove("btn-indigo");
          return false;
        }
        if (Object.keys(value).filter(x => value[x].error).length > 0) {
          document.querySelector(".btn-next").disabled = true;
          document.querySelector(".btn-next").classList.remove("btn-indigo");
        } else {
          document.querySelector(".btn-next").disabled = false;
          document.querySelector(".btn-next").classList.add("btn-indigo");
        }
      },
      deep: true,
    },
    isNotFillFull(value) {
      if (
        Object.keys(this.errors).filter(x => this.errors[x].error).length > 0
      ) {
        document.querySelector(".btn-next").disabled = true;
        document.querySelector(".btn-next").classList.remove("btn-indigo");
        return false;
      }
      if (!value) {
        document.querySelector(".btn-next").disabled = false;
        document.querySelector(".btn-next").classList.add("btn-indigo");
      } else {
        document.querySelector(".btn-next").disabled = true;
        document.querySelector(".btn-next").classList.remove("btn-indigo");
      }
    }
  },
  computed: {
    REGEX_PHONE() {
      return REGEX_PHONE;
    },
    REGEX_UNICODE() {
      return REGEX_UNICODE;
    },
    REGEX_EMAIL_SYMBOL() {
      return REGEX_EMAIL_SYMBOL;
    }
  },
  methods: {
    validate() {
      let { isValid, error } = _validateFormI18n(
        this.data,
        this.errors,
        Object.keys(this.errors)
      );
      this.errors = error;
      if (!isValid) {
        this.isNotFillFull = true;
        document.querySelector(".btn-next").disabled = true;
        document.querySelector(".btn-next").classList.remove("btn-indigo");
        return false;
      }

      this.$store.commit("storePersonData", this.data);
      this.$emit("validate");
    },
  }
};
</script>
